export const buildAPBDeepLink = (
    entityType: string,
    entityTypeId: string,
    marketplaceId: string,
    entityId: string,
    apbRules: string[],
): string => {
    // Following logic from https://code.amazon.com/packages/RecommendationDetail/blobs/0938e1d4d056b3f8b3807bb3b2f24997a13d325c/--/app/components/ActionBar/ActionBar.tsx#L120
    // APB Deep Link is expected to be:
    // ATC: https://<atc-root-domain>/global-action-center/<marketplaceId>/<vendorOrSellerCode>?entityId=<entityId>&filters={"filter_opportunity_reference_id":["apbRule1","apbRule2"]}
    const vendorSellerCode = getVendorSellerCode(entityType, entityTypeId);
    const apbLink = new URL(
        `/global-action-center/${marketplaceId}/${vendorSellerCode}`,
        window.location.origin,
    );

    apbLink.searchParams.append("entityId", entityId);

    const apbFilters = {
        filter_opportunity_reference_id: apbRules,
    };
    apbLink.searchParams.append("filters", JSON.stringify(apbFilters));

    return apbLink.toString();
};

export const getVendorSellerCode = (
    entityType: string,
    entityTypeId: string,
): string => {
    // Helper originally from CAIRE https://code.amazon.com/packages/RecommendationDetail/blobs/46b09dd527890fb6743de681dc5eff30c0ef4ae4/--/app/utilities/componentHelper/actionBarHelpers.ts#L9
    if (entityType === "BRAND") {
        return `vendor-${entityTypeId}`;
    }
    return `seller-${entityTypeId}`;
};
